import { routes } from './registry'
import type { RouteCategory, RouteDefinition } from './types'

/**
 * Collect all route paths by category (for server-side use)
 */
function collectRoutesByCategory(): Map<RouteCategory, string[]> {
  const result = new Map<RouteCategory, string[]>()

  function traverse(obj: unknown) {
    if (typeof obj === 'object' && obj !== null) {
      if ('path' in obj && 'category' in obj) {
        const route = obj as RouteDefinition
        const paths = result.get(route.category) ?? []
        // Get base path without params for matching
        const basePath = route.path.split('/:')[0]
        if (!paths.includes(basePath)) {
          paths.push(basePath)
        }
        result.set(route.category, paths)
      } else {
        for (const value of Object.values(obj)) {
          traverse(value)
        }
      }
    }
  }

  traverse(routes)
  return result
}

const routesByCategory = collectRoutesByCategory()

/**
 * Legal pages (no locale prefix)
 */
export const LEGAL_PAGES = routesByCategory.get('legal') ?? []

/**
 * External app paths (no locale prefix)
 */
export const EXTERNAL_APP_PATHS = routesByCategory.get('external-app') ?? []

/**
 * All paths that should not have locale prefixes
 */
export const NO_LOCALE_PATHS = [...LEGAL_PAGES, ...EXTERNAL_APP_PATHS]
